<template>
  <div>
    <template>
      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <Subheader icon="mdi-card-text" title="Allgemein"></Subheader>
            <div class="mt-7">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model.number="rankLocal.sortKey"
                          type="number"
                          clearable
                          label="Sortierschlüssel"
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model.trim="rankLocal.shortTitle"
                          :counter="6"
                          clearable
                          label="Kurzbezeichnung"
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model.trim="rankLocal.title"
                          :counter="32"
                          label="Bezeichnung"
                          required
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-switch
                          v-model="rankLocal.isActive"
                          dense
                          inset
                          label="Aktiver Dienstgrad"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col v-if="mode === 'edit' && organizationId && itemId" cols="12">
            <Subheader icon="mdi-image" title="Grafik"></Subheader>
            <div class="mt-7">
              <ImageUpload
                :storagePath="`organizations/${organizationId}/ranks/${itemId}`"
                fileName="rank"
                :acceptedFileTypes="['image/png', 'image/jpeg']"
                :maxFileSize="2000000"
                label="Grafik für Dienstgrad auswählen"
                hint="Bild im Format PNG oder JPEG hochladen. Maximale Dateigröße: 2 MB."
                uploadButtonText="Grafik hochladen"
                successMessage="Grafik für Dienstgrad erfolgreich aktualisiert. Es kann einige Minuten dauern, bis die Änderung aktiv wird."
                @upload-complete="onImageUploadComplete"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import ImageUpload from "@/components/_systemwide/ImageUpload.vue";

export default {
  name: "rank-editor",
  props: {
    rank: {},
    mode: {
      type: String,
      default: "new",
      required: true,
      validator: function (value) {
        return ["new", "edit"].indexOf(value) !== -1;
      },
    },
    organizationId: {
      type: String,
      default: "",
    },
    itemId: {
      type: String,
      default: "",
    },
  },
  components: {
    Subheader,
    ImageUpload,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
    };
  },
  model: {
    prop: "rank",
    event: "rankChange",
  },
  computed: {
    rankLocal: {
      get: function () {
        return this.rank;
      },
      set: function (value) {
        this.$emit("rankChange", value);
      },
    },
  },
  methods: {
    onImageUploadComplete(data) {
      this.$emit("image-uploaded", data);
    },
  },
};
</script>
